import script from "./MyDecksView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyDecksView.vue?vue&type=script&setup=true&lang=js"

import "./MyDecksView.vue?vue&type=style&index=0&id=1570ddd2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1570ddd2"]])

export default __exports__